<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Master Files / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="$refs.createCategory.show()"
          v-if="role_modules.some(item => item.value == 'category.create')"
        >
          <i class="uil-plus mr-1"></i> {{$t('category.action.create_record')}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
      <Table
        ref="list"
        :useView="role_modules.some(item => item.value == 'category.view')"
        :useEdit="role_modules.some(item => item.value == 'category.edit')"
        noTitle
        :params="params"
        :fields="fields"
        :action="role_modules.some(item => item.value == 'tag') ? action : false"
        @openFormBar="openFormBar"
      />
      </div>
    </div>
    <Dialog
      centered
      title="View Category"
      ref="viewCategory"
      size="md"
      :component="viewComponent"
      :parameters="{ categoryID, submitted }"
      v-if="role_modules.some(item => item.value == 'category.view')"
    />
    <Dialog
      centered
      autoload
      is_reset_model
      title="Create Category"
      ref="createCategory"
      size="md"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :component="createComponent"
      @onYes="onCreateCategory"
      v-if="role_modules.some(item => item.value == 'category.create')"
    />
    <Dialog
      centered
      autoload
      title="Update Category"
      ref="editCategory"
      size="md"
      yesText="Update"
      noText="Cancel"
      :buttonDisable="updated"
      :component="editComponent"
      :parameters="{ categoryID, submitted }"
      @onYes="onUpdateCategory"
      v-if="role_modules.some(item => item.value == 'category.edit')"
    />
  </div>
</template>

<script>
import Table from '@components/table'
import moment from 'moment/moment'
import Dialog from '@components/offcanvas'
import CreateComponent from './components/dialogs/create.vue'
import ViewComponent from './components/dialogs/view.vue'
import EditComponent from './components/dialogs/edit.vue'

import error from '@utils/error'

export default {
  components: {
    Table,
    Dialog
  },
  computed: {
    createComponent () {
      return CreateComponent
    },
    viewComponent () {
      return ViewComponent
    },
    editComponent () {
      return EditComponent
    }
  },
  data() {
    return {
      fields: [
				{
          label: this.$t('category.table.name'), 
          key:"name",
          sortable: true
        },
        {
          label: this.$t('category.table.date_created'), 
          key:'date_created', formatter: (val) => moment(val).format('YYYY-MM-DD')
        },
        {
          key:'actions',
          label:''
        }
      ],
      params: {},
      action: 'category/pagination',
      categoryID: '',
      submitted: false,
      created: false,
      updated: false,
    }
  },
  methods: {
    openFormBar(id, editMode = false) {
      this.categoryID = id
      if(!editMode){
        this.$refs.viewCategory.show()
      }else{
        this.$refs.editCategory.show()
      }
    },
    
    onCreateCategory(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('category/create', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData();
          this.$refs.createCategory.hide();
          this.$bvToast.toast('Category successfully created!', {
            title: "Notification",
            variant: "success"
          });
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onUpdateCategory(val) {
      this.updated = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id ? model.id : ''

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('category/update', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData()
          this.$refs.editCategory.hide()
          this.submitted = !this.submitted
          this.$bvToast.toast(`Category successfully updated!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
  }
}
</script>